import SelectMenu from "../../../controls/SelectMenu";
import Input from "../../../controls/Input";

export default function SalesByPluFilters(props) {
  const { filters, setFilters, products } = props;
  return (
    <div className="grid grid-cols-6 gap-3">
      <SelectMenu
        title="Product"
        handleInputChange={(e) =>
          setFilters({ ...filters, product: e.target.value })
        }
        name="product"
        options={products}
        value={filters.product}
      />
    </div>
  );
}
